import { Injectable } from '@angular/core';

@Injectable()
export class StyleService {
    private _headElement: HTMLHeadElement;
    private get headElement(): HTMLHeadElement {
        if (!this._headElement && document.getElementsByTagName("head").length > 0) {
            this._headElement = document.getElementsByTagName("head")[0];
        }
        return this._headElement;
    }
    private _cssStyleSheet: CSSStyleSheet;
    private get cssStyleSheet(): CSSStyleSheet {
        if (!this._cssStyleSheet) {
            if (!document.styleSheets || this.headElement === null) return null;
            // Get the first style sheet that is enabled and mediaText is empty or screen.
            this._cssStyleSheet = Array.from(document.styleSheets).find(s => !s.disabled && (s.media.mediaText == "" || s.media.mediaText.indexOf("screen") !== -1)) as CSSStyleSheet;
            // If the style sheet doesn't exist yet, then create it.
            if (!this._cssStyleSheet) this._cssStyleSheet = this.createCssStyleSheet();
        }
        return this._cssStyleSheet;
    }
    constructor() { }

    public static hexToRGB(hex, alpha) {
        var r = parseInt(hex.slice(1, 3), 16),
            g = parseInt(hex.slice(3, 5), 16),
            b = parseInt(hex.slice(5, 7), 16);

        if (alpha) {
            return "rgba(" + r + ", " + g + ", " + b + ", " + alpha + ")";
        } else {
            return "rgb(" + r + ", " + g + ", " + b + ")";
        }
    }

    public setStyle(selectorText: string, styleName: string, value: string): void {
        let rule: CSSStyleRule = this.getStyleRule(selectorText);
        if (!rule) return;
        rule.style[styleName] = value;
    }
    public setStyles(selectorText: string, styles: { [styleName: string]: string } | CSSStyleDeclaration) {
        let rule: CSSStyleRule = this.getStyleRule(selectorText);
        if (!rule) return;
        Object.keys(styles).forEach(styleName => {
            rule.style[styleName] = styles[styleName];
        });
    }
    private createCssStyleSheet(): CSSStyleSheet {
        // Create the style sheet element.
        let styleSheetElement = document.createElement("style");
        styleSheetElement.type = "text/css";
        // Append the style sheet element to the head.
        this.headElement.appendChild(styleSheetElement);
        return styleSheetElement.sheet as CSSStyleSheet;
    }
    private getStyleRule(selectorText: string): CSSStyleRule {
        if (!this.cssStyleSheet) return;
        const rules: CSSRuleList = this.cssStyleSheet.cssRules?.length > 0
            ? this.cssStyleSheet.cssRules
            : null;
        let rule: CSSStyleRule = rules
            ? Array.from(rules).find(r => r instanceof CSSStyleRule && r.selectorText.toLowerCase() == selectorText.toLowerCase()) as CSSStyleRule
            : null;
        // If the selector rule does not exist, create it.
        if (!rule) {
            let ruleIndex = this.cssStyleSheet.insertRule(selectorText + "{ }", rules.length);
            rule = rules[ruleIndex] as CSSStyleRule;
        }
        return rule;
    }


    public textColorBasedOnBgColor(bgColor: string): string {
        const color = (bgColor.charAt(0) === '#') ? bgColor.substring(1, 7) : bgColor;
        const r = parseInt(color.substring(0, 2), 16); // hexToR
        const g = parseInt(color.substring(2, 4), 16); // hexToG
        const b = parseInt(color.substring(4, 6), 16); // hexToB
        return (((r * 0.299) + (g * 0.587) + (b * 0.114)) > 186)
            ? 'black'
            : 'white';
    }
}